<template>
  <button 
    v-if="hasAiFeature" 
    type="button" 
    @click="$emit('click', $event)" 
    :disabled="loading" 
    class="text-blue-500 hover:text-blue-600 focus:outline-none flex items-center justify-center p-1 rounded-full hover:bg-blue-50 transition-colors shrink-0"
    :class="customClass"
  >
    <SparklesIcon v-if="!loading" class="w-5 h-5" />
    <div v-else class="animate-spin rounded-full h-4 w-4 border-2 border-blue-500 border-t-transparent"></div>
  </button>
</template>

<script setup>
import { computed, defineProps, defineEmits } from 'vue';
import { SparklesIcon } from '@heroicons/vue/24/outline';
import userStore from '@/store/user.store';

defineProps({
  loading: {
    type: Boolean,
    default: false
  },
  customClass: {
    type: String,
    default: ''
  }
});

defineEmits(['click']);

const hasAiFeature = computed(() => userStore.getters.hasAiFeature);
</script>
